/**
 * Hands a blob to the browser's own download machinery under the given file name.
 *
 * A plain link to the endpoint would also work — the content route is cookie-authenticated
 * and deliberately sets a permissive `Cross-Origin-Resource-Policy` — but the bulk download
 * is a `POST` and has no URL to link to, so both paths go through a blob and stay one
 * implementation.
 *
 * The object URL is revoked on the next macrotask rather than immediately: Safari cancels an
 * in-flight download when the URL it points at disappears in the same task.
 *
 * @param {Blob} blob - The bytes to save
 * @param {string} filename - The name the download is offered under
 */
export function saveBlob(blob: Blob, filename: string): void {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}
